import React, { useContext, useEffect } from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import { CycleFilterContext } from "./context/CycleFilterContext";
import { getCycleDataFromParent } from "../handler/ParentDataHandler";
import { FormattedMessage } from "react-intl";
import Select, { SelectOption } from "@amzn/meridian/select";
import { useDeviceLayout } from "../common/context/DeviceLayoutContext";
import Text from "@amzn/meridian/text";

const CycleFilter = () => {
  const { cycles, dispatch } = useContext(CycleFilterContext);
  const { spacingInset_shorthand2 } = useDeviceLayout();

  const value = cycles.selectedCycles ? cycles.selectedCycles[0] : "";

  useEffect(() => {
    getCycleDataFromParent().then((cycleData) => {
      cycleData["defaultCycleFilter"] = true;
      dispatch({ type: "INITIALIZE_CYCLES", cycleData });
    });
  }, []);

  const CycleFilter = () => (
    <Column spacing="none">
      <Row
        width="100%"
        spacingInset={spacingInset_shorthand2}
        alignmentHorizontal={"end"}
      >
        <Text type={"h200"}>
          <FormattedMessage id="cycle_filter.cycle" defaultMessage="Cycle" />
        </Text>
        <Select
          value={cycles.selectedCycles[0]}
          onChange={(value) => dispatch({ type: "SELECT_CYCLE", cycle: value })}
          width={150}
          placeholder={value}
          size={"small"}
        >
          {cycles.allCycles.map((cycle) => {
            return (
              <SelectOption
                value={cycle.cycleName}
                label={cycle.displayableName}
                key={cycle.cycleName}
              />
            );
          })}
        </Select>
      </Row>
    </Column>
  );

  return <CycleFilter />;
};

export default CycleFilter;



// WEBPACK FOOTER //
// ./src/components/overview/CycleFilterv3.js